interface RowProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  gap?: number;
}

export function RowGroup({ children, gap = 3, className = '' }: RowProps) {
  return (
    <div className={`d-flex flex-row w-100 gap-${gap} w-100 p-2 ${className}`}>{children}</div>
  );
}
